module.exports = __webpack_public_path__ + "static/media/console-L.inline.37edf470.svg";